import { supabase } from '@/lib/supabase'
import { normalizeLinkedOpportunityId } from '../utils/normalizeLinkedOpportunityId'

export async function fetchLinkedOpportunityVisionCount(params: {
  opportunityId: number
  excludeVisionId?: number | null
}): Promise<number> {
  const opportunityId = normalizeLinkedOpportunityId(params.opportunityId)
  if (!opportunityId) return 0

  const excludeId =
    params.excludeVisionId != null && Number.isFinite(Number(params.excludeVisionId))
      ? Math.floor(Number(params.excludeVisionId))
      : null

  let query = supabase
    .from('market_visions' as any)
    .select('id', { count: 'exact' })
    .eq('linked_opportunity_id', opportunityId)

  if (excludeId) {
    query = query.neq('id', excludeId)
  }

  const { data, count, error } = await query

  if (error) {
    throw error
  }

  if (typeof count === 'number') return count
  return Array.isArray(data) ? data.length : 0
}
